// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/navBar/navBarCtrl.js#1 $
/*
* @description
* Nav Bar is displayed across the top of the window. It contains the menu toggle and profile panel
*
*/
angular.module('tcApp')
.controller('NavBarCtrl', function($scope, $window, $location, $route, $log, $mdSidenav, $mdPanel, $mdMedia,
									GlobalService, WorkflowService, BreadcrumbService, ToastService, OverlayService) {

	var onInit = function() {
		// Data to display
		$scope.data = {};
		$scope.counters = {};
		$scope.viewModel = {
			showNavBar: true,
			showProfile: false,
			showMenu: false,
			displayHome: GlobalService.logonData.displayStaticHome,
			displayMessaging: false,
			showingTools: false,
			sessionLocked: false,
			pathToHelpText: null,
			chartName: null,
			showSkipNav: GlobalService.logonData.extraAccessibilitySupport,
			profilePanelOpen: false,
			showAdvancedTools: true,
			showAboutLink: true,
			helpEnabled: false,
			langCode: '',
			region: '',
			allowChangePassword: true,
		};
		$scope.BreadcrumbService = BreadcrumbService;
	};

	var profilePanelCtrl = function(mdPanelRef, $scope, data, viewModel, globalStrings, OverlayService) {
		$scope.data = data;
		$scope.viewModel = viewModel;
		$scope.globalStrings = globalStrings;

		$scope.logout = function() {
			GlobalService.logout(true);
			mdPanelRef.close();
		};

		$scope.lockSession = function() {
			GlobalService.lockSession(true);
			mdPanelRef.close();
		};

		$scope.changePassword = function() {
			$location.url('/Component/SSUser.EditPassword');
			mdPanelRef.close();
		};

		$scope.showLocationPicker = function() {
			if ($location.path() !== '/Component/SSUserOtherLogonLoc.ChangeLoc') {
				$location.url(WorkflowService.getNextLevelUrl('/Component/SSUserOtherLogonLoc.ChangeLoc'));
			}
			mdPanelRef.close();
		};
		$scope.showLanguagePicker = function() {
			if ($location.path() !== '/Component/SSLanguage.ChooseLanguage') {
				$location.url(WorkflowService.getNextLevelUrl('/Component/SSLanguage.ChooseLanguage'));
			}
			mdPanelRef.close();
		};

		$scope.openAbout = function($event) {
			OverlayService.open({
				componentName: 'websys.About.Custom',
				params: '&CONTEXT=SPROFILEPANEL',
				event: $event
			});
			mdPanelRef.close();
		};
	};

	$scope.openProfilePanel = function($event) {
		var profilePanelLinkSelector = '#tc_NavBar-misc-profileToggle';
		var panelPosition = $mdPanel.newPanelPosition().relativeTo(profilePanelLinkSelector)
		.addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.BELOW)
		.withOffsetY('2px');
		var panelConfig = {
			controller: profilePanelCtrl,
			controllerAs: 'ctrl',
			bindToController: false,
			position: panelPosition,
			targetEvent: $event,
			templateUrl: 'template/navBar/profilePanel.html',
			clickOutsideToClose: true,
			escapeToClose: true,
			focusOnOpen: true,
			trapFocus: true,
			locals: {
				data: $scope.data,
				viewModel: $scope.viewModel,
				globalStrings: $scope.globalStrings
			},
			onRemoving: function() {
				$scope.viewModel.profilePanelOpen = false;
				GlobalService.onModalToggle(false);
			},
			origin: profilePanelLinkSelector
		};
		$mdPanel.open(panelConfig);
		$scope.viewModel.profilePanelOpen = true;
		GlobalService.onModalToggle(true);
	};

	$scope.navHome = function() {
		if (angular.isDefined(GlobalService.logonData.startWorklist)) {
			WorkflowService.mainMenuData = {};
			$location.url('/Worklist?Dialog=0');
		} else {
			WorkflowService.mainMenuData = {};
			$location.url('/Workflow?Dialog=0');
		}
		// Reset main menu to display the main menu header if side menu is toggled
		GlobalService.setMenuTools(false);
	};

	$scope.navBack = function() {
		$window.history.back();
	};

	$scope.showMessages = function() {
		if ($location.path() == '/Component/SSMessageRecipient.List') {
			$route.reload();
		} else {
			// treat Messages link as Main Menu
			WorkflowService.mainMenuData = {caption: $scope.globalStrings['Messages']};
			var messagesUrl = '/Component/SSMessageRecipient.List?PatientID=&EpisodeID=';
			messagesUrl = GlobalService.maskUrl(messagesUrl);
			$location.url(messagesUrl);
		}
	};

	$scope.showNotifications = function() {
		if ($location.path() == '/Component/websys.Notification') {
			$route.reload();
		} else {
			var notificationUrl = '/Component/websys.Notification';
			var patientID = $scope.counters.notifications.PatientID;
			if (patientID == '') patientID = GlobalService.globalContext.PatientID;
			var params = '?PatientID=' + patientID;
			notificationUrl += params;
			notificationUrl = GlobalService.maskUrl(notificationUrl);
			$location.url(WorkflowService.getNextLevelUrl(notificationUrl));
		}
	};

	$scope.skipNav = function($event) {
		if ($event) {
			$event.stopImmediatePropagation();
			$event.preventDefault();
		}

		if ((angular.isDefined(GlobalService.globalContext))
			&& (GlobalService.globalContext.PatientID !== '')) {
			var bannerSkipNav = $window.document.getElementById('tc_Banner-misc-skipNav');
			if (bannerSkipNav) bannerSkipNav.focus();
		} else {
			GlobalService.focusFirst(false, true);
		}
	};

	$scope.getSkipNavLabel = function() {
		if ((angular.isDefined(GlobalService.globalContext)) && (GlobalService.globalContext.PatientID !== '')) {
			return $scope.globalStrings['XSKIPNAVBANNER'];
		} else {
			return $scope.globalStrings['XSKIPNAVMAIN'];
		}

	};

	// Returns the help text path based on the current route
	var getHelpPath = function() {
		var path = $location.path();
		var pathArray = path.split('/');
		if (['ACN','Floorplan','LayoutEdit','ClinicalViewer','PWB','OrderEntry'].indexOf(pathArray[1]) !== -1) {
			// For these routes, the help should not be dynamic
			path = ('/' + pathArray[1] + '/');
		} else if (['Component','Chart','Worklist'].indexOf(pathArray[1]) !== -1) {
			// For these routes, the help should only be based on the first element of the current page
			path = ('/' + pathArray[1] + '/');
			var pathElement;
			if ((pathArray[1] === 'Chart') && ($scope.viewModel.chartName !== null)) {
				pathElement = $scope.viewModel.chartName;
			} else {
				pathElement = pathArray[2];
			}
			path += (pathElement + '/');
		}
		if (path.charAt(path.length - 1) !== '/') path += '/';
		return path;
	};

	// Returns the parameters to pass to the help text viewer that displays
	// component and context specific help for the currently displayed component
	var getHelpParams = function() {
		var params = '';

		if (angular.isDefined(GlobalService.primaryComponent)) {
			if (angular.isDefined(GlobalService.primaryComponent.componentName)
				&& (GlobalService.primaryComponent.componentName !== '')) {
				params += ('&HelpComponentName=' + encodeURIComponent(GlobalService.primaryComponent.componentName));
				if (angular.isDefined(GlobalService.primaryComponent.componentContext)
					&& (GlobalService.primaryComponent.componentContext !== '')) {
					params += ('&HelpComponentContext=' + encodeURIComponent(GlobalService.primaryComponent.componentContext));
				}
				if (angular.isDefined(GlobalService.primaryComponent.modelClassName)
				&& (GlobalService.primaryComponent.modelClassName !== '')) {
					params += ('&HelpModelClassName=' + encodeURIComponent(GlobalService.primaryComponent.modelClassName));
				}
				if (angular.isDefined(GlobalService.primaryComponent.componentHtmlName)
					&& (GlobalService.primaryComponent.componentHtmlName !== '')) {
					// Trigger event to get the nested components that are displayed when Help icon is clicked
					GlobalService.callFunction(GlobalService.primaryComponent.componentHtmlName,
												'getNestedComponentDetails', [], function(nestedComponentDetails) {
						if (angular.isArray(nestedComponentDetails.nestedComponentNames)) {
							params += ('&HelpNestedComponentNames='
										+ encodeURIComponent(nestedComponentDetails.nestedComponentNames.join(',')));
			}
						if (angular.isArray(nestedComponentDetails.nestedModelClassNames)) {
							params += ('&HelpNestedModelClassNames='
										+ encodeURIComponent(nestedComponentDetails.nestedModelClassNames.join(',')));
						}
					});
				}
			}
			if (angular.isDefined(GlobalService.primaryComponent.routePath)
				&& (GlobalService.primaryComponent.routePath !== '')) {
				params += ('&HelpCustomRoute=' + encodeURIComponent(GlobalService.primaryComponent.routePath));
			}
		}
		if ($scope.viewModel.region !== '') {
			params += ('&HelpRegion=' + encodeURIComponent($scope.viewModel.region));
		}
		if ($scope.viewModel.langCode !== '') {
			params += ('&HelpLanguage=' + encodeURIComponent($scope.viewModel.langCode));
		}

		return params;
	};

	$scope.showHelp = function($event) {
		if ($scope.viewModel.sessionLocked) return;
		var helpUrl;

		if ($scope.viewModel.helpEnabled) {
			helpUrl = ('system.HelpViewer.cls?' + getHelpParams());
			helpUrl = GlobalService.maskUrl(helpUrl);
			helpUrl = helpUrl.replace('#websys.csp?','system.HelpViewer.cls?');
			GlobalService.openWindow(helpUrl, ('tcdocs_' + Date.now()), '', true);
		} else {
			helpUrl = $scope.viewModel.pathToHelpText;
			if (helpUrl.charAt(helpUrl.length - 1) === '/') helpUrl = helpUrl.substr(0, (helpUrl.length - 1));
			helpUrl += getHelpPath();
			OverlayService.open({
				url: helpUrl,
				event: $event
			});
		}
	};

	$scope.toggleTools = function() {
		GlobalService.toggleTools();
	};

	$scope.showBreadcrumbs = function() {
		var data = BreadcrumbService.data;
		if (((angular.isDefined(data.menuCaption)) && (!$mdMedia('xs'))) || (data.breadcrumbs.length > 1)) {
			return true;
		}
		return false;
	};

	$scope.dumpSessionData = function() {
		$log.log($scope.data);
	};

	$scope.dumpPerfStats = function() {
		$log.log('Watchers: ', GlobalService.countWatchers());
	};

	var showAdvancedTools = function() {
		// Only show extra tools links where layout restrictions are not applied
		var logonData = GlobalService.getLogonData();
		if ((angular.isUndefined(logonData)) || (!angular.isString(logonData.layoutRestrictions))) return true;
		var layoutRestrictions = logonData.layoutRestrictions.split(',');
		if (!layoutRestrictions.length) return true;

		return false;
	};

	// Catch Global:updated event broadcasted by GlobalService
	var catchUpdateCounters = function(event, data) {
		if (!data) {
			data = {};
		}
		if (angular.isDefined(data.notifications)
			&& angular.isDefined(data.notifications.PatientID) && (data.notifications.PatientID != '')) {
			var notificationInc = data.notifications.notificationCounter;
			if (angular.isDefined($scope.counters.notifications)) {
				notificationInc = data.notifications.notificationCounter - $scope.counters.notifications.notificationCounter;
			}
			if (notificationInc > 0) {
				var message = $scope.globalStrings.strNewNotification1 + ' ' + notificationInc
					+ ' ' + $scope.globalStrings.strNewNotification2;
				ToastService.show({
					message: message
				});
			}
		}

		if (angular.isDefined(data.toasts)) {
			displayToasts(event, data.toasts);
			data.toasts = undefined; // remove toasts so that they aren't re-displayed when returning to the screen
		}
		$scope.counters = data;
	};

	var catchRefreshNotifications = function(event, data) {
		if (!data) {
			data = {};
		}
		$scope.counters.notifications = data;
	};

	// Displays toast notifications, either received from GlobalService or as part of the normal counters object
	var displayToasts = function(event, toasts) {
		if (!angular.isArray(toasts)) return;

		angular.forEach(toasts, function(toastMessage) {
			ToastService.show({
				message: toastMessage,
				type: ((toastMessage === $scope.globalStrings['XERROR']) ? 'error' : ''),
			});
		});
	};

	$scope.toggleLeft = function() {
		if ($scope.viewModel.sessionLocked) return;

		$mdSidenav('mainMenu').open()
			.then(function() {
				GlobalService.onModalToggle(true);
			});
	};

	// Catch Global:userLogon event broadcasted by GlobalService
	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.data = sessionData;
		$scope.globalStrings = sessionData.globalStrings;
		$scope.viewModel.showNavBar = true;
		if ((sessionData.menuData)
			&& (sessionData.menuData.mainMenu || sessionData.menuData.toolsMenu)) $scope.viewModel.showMenu = true;
		if (sessionData.logonData.isInSecurityOverride) {
			$scope.viewModel.showMenu = false;
		}
		$scope.viewModel.displayHome = sessionData.logonData.displayStaticHome;
		$scope.viewModel.displayMessaging = sessionData.configuration.misc.messagingEnabled;
		$scope.viewModel.helpEnabled = sessionData.configuration.misc.helpEnabled;
		$scope.viewModel.pathToHelpText = sessionData.configuration.misc.pathToHelpText;
		$scope.viewModel.showSkipNav = GlobalService.logonData.extraAccessibilitySupport;
		$scope.viewModel.showAdvancedTools = showAdvancedTools();
		$scope.viewModel.showAboutLink = !sessionData.configuration.misc.isHealthShare;
		$scope.viewModel.langCode = GlobalService.logonData.langCode;
		$scope.viewModel.region = GlobalService.logonData.region;
		if (GlobalService.logonData.isUserExternal || GlobalService.logonData.isUserLDAP) {
			$scope.viewModel.allowChangePassword = false;
		}
	});

	// Catch Global:toggleTools event broadcast by GlobalService
	$scope.$on('Global:toggleTools', function($event, newShowingTools) {
		$scope.viewModel.showingTools = newShowingTools;
	});

	$scope.$on('Global:updateCounters', catchUpdateCounters);

	$scope.$on('Global:refreshNotifications', catchRefreshNotifications);

	$scope.$on('Global:displayToasts', displayToasts);

	$scope.$on('Global:sessionLocked', function() {
		$scope.viewModel.sessionLocked = true;
		$scope.viewModel.showNavBar = false;
	});

	$scope.$on('Global:sessionUnlocked', function() {
		$scope.viewModel.sessionLocked = false;
		$scope.viewModel.showNavBar = true;
	});

	$scope.$on('Global:updateChartName', function(event, chartName) {
		$scope.viewModel.chartName = chartName;
	});

	onInit();
});
